
import { catchError, Observable } from 'rxjs';
import { HttpClient, HttpErrorResponse, HttpHeaders } from '@angular/common/http';
import { ErrorHandler, Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { PedidoClienteDTO } from 'src/app/model/pedidoClienteDTO';
import { environment } from 'src/environments/environment';
import { PedidoOutERP } from 'src/app/model/pedido.out.ERP';
import { CredencialesNeoNet } from 'src/app/model/credencialNeoNet';
import { PedidoDTO } from 'src/app/model/pedidoDTO';
import { TransaccionElectronicaDTO } from 'src/app/model/transaccionElectronicaDTO';


const httpOptions = {
    headers: new HttpHeaders({ 'Content-Type': 'application/json' })
  };

  @Injectable({
    providedIn: 'root'
  })
  export class PedidoService {
    private url : string = `${environment.HOST}/api/pedido`;
  
    constructor(
        private http : HttpClient,
        private router : Router
      ) { }

   

    
    
  nuevoPedido( idCliente : number, idDepto : Number,idMuni : Number,total : number,nombreRecibe : String,direccionEntrega :String,telefono:String,idFormaPago:number,detalleCompra:String,numeroTarjeta:string,vencimiento:string,codigoSeguridad:string,nit:string,nombreFactura:string,direccionFactura:string,systemTraceNo:string,telefonoPropina:string,nombreTarjeta:string,idCodigoDescuento:number) {
    return this.http.post(`${this.url}/nuevo-pedido/${idCliente}/${idDepto}/${idMuni}/${total}/${nombreRecibe}/${direccionEntrega}/${telefono}/${idFormaPago}/${detalleCompra}/${numeroTarjeta}/${vencimiento}/${codigoSeguridad}/${nit}/${nombreFactura}/${direccionFactura}/${systemTraceNo}/${telefonoPropina}/${nombreTarjeta}/${idCodigoDescuento}`, "");
  }


  



  apartarPedido( idPedido : number, idProducto : Number,indice : Number,idUsuario : number,observacion : String,idSucursal:number,cantidad:number,codigoerp:number,colorerp:String,coloriderp:number) {
    return this.http.post(`${this.url}/apartar-pedido/${idPedido}/${idProducto}/${indice}/${idUsuario}/${observacion}/${idSucursal}/${cantidad}/${codigoerp}/${colorerp}/${coloriderp}`, "");
  }


  enviarPedido( idPedido : number, idProducto : Number,indice : Number,idUsuario : number,numeroGuia : String,cantidad:number,codigoerp:number,colorerp:String) {
    return this.http.post(`${this.url}/enviar-pedido/${idPedido}/${idProducto}/${indice}/${idUsuario}/${numeroGuia}/${cantidad}/${codigoerp}/${colorerp}`, "");
  }


  anularDetallePedido( indice : number, idPedido : Number,idEstado : Number,idUsuario : number) {
    return this.http.post(`${this.url}/anular-detalle-pedido/${indice}/${idPedido}/${idEstado}/${idUsuario}`, "");
  }
  finalizarPedido( idPedido : number, idUsr : Number) {
    return this.http.post(`${this.url}/finalizar-pedido/${idPedido}/${idUsr}`, "");
  }


  getPedidoByCliente(idCliente : number):Observable<PedidoClienteDTO[]>{
    return this.http.get<PedidoClienteDTO[]>(`${this.url}/pedido-by-cliente-proceso-finalizado/${idCliente}`);
 }


 getPedidoSelected(idPedido : number):Observable<PedidoClienteDTO[]>{
  return this.http.get<PedidoClienteDTO[]>(`${this.url}/pedido-selected/${idPedido}`);
}


 getPedidoOutErpSolicitado(pedidoId:number):Observable<PedidoOutERP[]>{
  return this.http
  .get<PedidoOutERP[]>(`${this.url}/pedido-out-erp-solicitado/${pedidoId}`);
}

getPedidoOutErpApartado(pedidoId:number):Observable<PedidoOutERP[]>{
  return this.http.get<PedidoOutERP[]>(`${this.url}/pedido-out-erp-apartado/${pedidoId}`);
  ;
}
 


generarSystemTraceNo( idUsuario : number) {
  return this.http.post(`${this.url}/generar-system-traceno/${idUsuario}`, "");
}


actualizaPagoTarjeta(idPedido:number,tarjeta:string,systemtraceno:string,authresponse:string,retrievalresponse:string,total:number,nombreTarjeta:string) {
  return this.http.post(`${this.url}/actualiza-pago-tarjeta/${idPedido}/${tarjeta}/${systemtraceno}/${authresponse}/${retrievalresponse}/${total}/${nombreTarjeta}`, "");
}

anulaPagoTarjeta(idTransaccion:number,idPedido:number,tarjeta:string,systemtraceno:string,authresponse:string,retrievalresponse:string,total:number,timelocaltrans:any,datelocaltrans:any) {
  return this.http.post(`${this.url}/anula-pago-tarjeta/${idTransaccion}/${idPedido}/${tarjeta}/${systemtraceno}/${authresponse}/${retrievalresponse}/${total}/${timelocaltrans}/${datelocaltrans}`, "");
}


getPedidoByIdClienteUsuario(idUsuario:number):Observable<PedidoClienteDTO[]>{
  return this.http.get<PedidoClienteDTO[]>(`${this.url}/pedido-by-cliente-usuario/${idUsuario}`);
}

getCredencialNeoNet():Observable<CredencialesNeoNet[]>{
  return this.http.get<CredencialesNeoNet[]>(`${this.url}/credencial-neo-net`);
}


getTransaccionElectronica(idPedido:number):Observable<TransaccionElectronicaDTO[]>{
  return this.http.get<TransaccionElectronicaDTO[]>(`${this.url}/transaccion-electronica/${idPedido}`);
}


getTransaccionElectronicaById(idTransaccion:number):Observable<TransaccionElectronicaDTO[]>{
  return this.http.get<TransaccionElectronicaDTO[]>(`${this.url}/transaccion-electronica-by-id/${idTransaccion}`);
}


    }